import { useQuery } from "@tanstack/react-query";
import { BenchmarkingDashboardDetails } from "@app/overviews/network-benchmarking-dashboard/dashboard-details/shared/BenchmarkingDashboardDetails";
import { NetworkComparisonFiltersPayload } from "@app/overviews/network-benchmarking-dashboard/filters/network-comparison-filters/shared/NetworkComparisonFiltersPayload";
import { BenchmarkingServiceType } from "@app/overviews/network-benchmarking-dashboard/filters/shared/utility";

export interface BenchmarkingDashboardDetailsResult {
  dashboardDetailsData: BenchmarkingDashboardDetails[] | undefined;
  isLoading: boolean;
}

export const BENCHMARKING_DASHBOARD_DETAILS_QUERY_KEY_PREFIX = "benchmarking-dashboard-details";

export const useBenchmarkingDashboardDetails = (
  service: BenchmarkingServiceType,
  filtersPayload: NetworkComparisonFiltersPayload
): BenchmarkingDashboardDetailsResult => {
  const queryResult = useQuery<BenchmarkingDashboardDetails[]>({
    queryFn: ({ signal }) => service.getDashboardDetailsData(filtersPayload, signal),
    queryKey: [BENCHMARKING_DASHBOARD_DETAILS_QUERY_KEY_PREFIX, service?.lineOfBusiness, JSON.stringify(filtersPayload)],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    dashboardDetailsData: queryResult.data,
    isLoading: queryResult.isFetching,
  };
}

export default useBenchmarkingDashboardDetails;
